<div class="project-create-cont" *ngIf="!loading; else loader">
  <awc-input
    label="Project Name"
    [hint]="!showHint ? '' : 'Please enter a title'"
    [required]="true"
    placeholder="Enter a name for your new project"
    (changes)="title = $event.toString()"
    ></awc-input>
  <awc-textarea
    label="Project Description"
    [placeholder]="'Add Description'"
    [lines]="5"
    (changes)="description = $event"></awc-textarea>
  <awc-button
    text="Create"
    [type]="type"
    [size]="size"
    [awcSizing]="awcSizing"
    (buttonClicked)="confirm()"></awc-button>
</div>
<ng-template #loader>
  <div class="project-create-cont">
    <awc-icon [icon]="spinner"></awc-icon>
  </div>
</ng-template>
